/**
 * CallRescheduleModal - Модальное окно для переноса звонка
 */
import React, { useState } from 'react';
import {
  Modal,
  Textarea,
  Button,
  Group,
  Stack,
  Alert,
  Text,
} from '@mantine/core';
import { DatePickerInput, TimeInput } from '@mantine/dates';
import { IconAlertCircle, IconCalendarEvent, IconCalendar, IconClock } from '@tabler/icons-react';

const CallRescheduleModal = ({
  opened,
  onClose,
  onSubmit,
  call,
  loading = false,
}) => {
  const [newDate, setNewDate] = useState(null);
  const [newTime, setNewTime] = useState('');
  const [reason, setReason] = useState('');
  const [error, setError] = useState(null);

  // Сброс формы при открытии
  React.useEffect(() => {
    if (opened) {
      // По умолчанию завтра в то же время
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      setNewDate(tomorrow);

      // Если есть время из звонка, используем его
      if (call?.call_datetime) {
        const callDate = new Date(call.call_datetime);
        const hours = String(callDate.getHours()).padStart(2, '0');
        const minutes = String(callDate.getMinutes()).padStart(2, '0');
        setNewTime(`${hours}:${minutes}`);
      } else {
        setNewTime('10:00');
      }

      setReason('');
      setError(null);
    }
  }, [opened, call]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!newDate) {
      setError('Укажите новую дату звонка');
      return;
    }

    if (!newTime) {
      setError('Укажите новое время звонка');
      return;
    }

    try {
      // Собираем дату и время
      const [hours, minutes] = newTime.split(':').map(Number);
      const newDatetime = new Date(newDate);
      newDatetime.setHours(hours || 0, minutes || 0, 0, 0);

      await onSubmit({
        new_datetime: newDatetime.toISOString(),
        reason: reason.trim() || null,
      });
    } catch (err) {
      setError(err.message || 'Ошибка при переносе звонка');
    }
  };

  const contactName = call?.contact
    ? [call.contact.last_name, call.contact.first_name].filter(Boolean).join(' ')
    : 'Неизвестный контакт';

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Перенести звонок"
      size="md"
      radius="xl"
    >
      <form onSubmit={handleSubmit}>
        <Stack gap="md">
          {error && (
            <Alert icon={<IconAlertCircle size={16} />} color="red" variant="light">
              {error}
            </Alert>
          )}

          <Text size="sm" c="dimmed">
            Перенос звонка с <strong>{contactName}</strong>
          </Text>

          <Group grow>
            <DatePickerInput
              label="Новая дата"
              placeholder="Выберите дату"
              required
              value={newDate}
              onChange={setNewDate}
              leftSection={<IconCalendar size={16} />}
              valueFormat="DD.MM.YYYY"
              locale="ru"
              minDate={new Date()}
            />
            <TimeInput
              label="Новое время"
              placeholder="00:00"
              required
              value={newTime}
              onChange={(e) => setNewTime(e.target.value)}
              leftSection={<IconClock size={16} />}
            />
          </Group>

          <Textarea
            label="Причина переноса"
            placeholder="Клиент занят, перенёс на другой день..."
            autosize
            minRows={2}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />

          <Group justify="flex-end" mt="md">
            <Button variant="subtle" onClick={onClose}>
              Отмена
            </Button>
            <Button
              type="submit"
              loading={loading}
              leftSection={<IconCalendarEvent size={16} />}
            >
              Перенести
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
};

export default CallRescheduleModal;
